// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"63dc1ade","453":"54292a4b","455":"60fa4b3a","607":"023f0ec3","944":"9535e0af","977":"7a7b0c82"}[chunkId] + ".chunk.js";
};